import React, { useId } from 'react';
import { Box, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/** Consistent section labels for the source panel's expandable content. */
export function AdvisoryDisclosure({
  title,
  expanded,
  onToggle,
  children,
}: {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}) {
  const contentId = `advisory-disclosure-${useId().replace(/:/g, '')}`;
  return (
    <Box component="section">
      <Box component="h3" sx={{ margin: 0 }}>
        <Button
          size="small"
          aria-expanded={expanded}
          aria-controls={expanded ? contentId : undefined}
          onClick={onToggle}
          sx={theme => ({
            color: theme.colors.inkPrimary,
            fontSize: 12,
            fontWeight: 400,
            letterSpacing: '0.09em',
            textTransform: 'uppercase',
            padding: 0,
            minWidth: 0,
            gap: 1,
            textAlign: 'left',
            justifyContent: 'flex-start',
          })}
        >
          {title}
          <ExpandMoreIcon
            aria-hidden
            sx={{ fontSize: 18, transform: expanded ? undefined : 'rotate(-90deg)' }}
          />
        </Button>
      </Box>
      {expanded ? (
        <Box id={contentId} sx={{ marginTop: 1 }}>
          {children}
        </Box>
      ) : null}
    </Box>
  );
}
